<template>
	<div>
		<div class="form-section-base__block-outer">
			<div class="form-section-base__block-inner">
				<slot></slot>
				<v-row>
					<v-col cols="3">
						<v-text-field
							label="Фамилия"
							outlined
							v-model="v.lastName.$model"
							:errorMessages="getValidationErrorText(v.lastName)"
							:disabled="isFieldDisabled"
							@blur="v.lastName.$touch"
						/>
					</v-col>
					<v-col cols="3">
						<v-text-field
							label="Имя"
							outlined
							v-model="v.firstName.$model"
							:errorMessages="getValidationErrorText(v.firstName)"
							:disabled="isFieldDisabled"
							@blur="v.firstName.$touch"
						/>
					</v-col>
					<v-col cols="3">
						<v-text-field
							label="Отчество (при наличии)"
							outlined
							v-model="v.patronymic.$model"
							:errorMessages="getValidationErrorText(v.patronymic)"
							:disabled="isFieldDisabled"
							@blur="v.patronymic.$touch"
						/>
					</v-col>
					<v-col cols="3">
						<DateFieldCustom
							label="Дата рождения"
							:value="v.birthDate.$model"
							@change="v.birthDate.$model = $event"
							:errorMessage="v.birthDate"
							:max="new Date().toISOString()"
							:disabled="isFieldDisabled"
							@blur="v.birthDate.$touch"
						/>
					</v-col>
					<v-col cols="3">
						<v-text-field
							v-model.trim="v.snils.$model"
							:errorMessages="getValidationErrorText(v.snils)"
							label="СНИЛС"
							v-mask="Mask.SNILS"
							outlined
							:disabled="
            isFieldDisabled || v.mrpDisabled.$model.includes(FieldName.SNILS)
          "
							@blur="v.snils.$touch"
						/>
					</v-col>
					<v-col cols="3">
						<v-text-field
							v-model="v.inn.$model"
							:errorMessages="getValidationErrorText(v.inn)"
							label="ИНН"
							v-mask="Mask.INN"
							outlined
							:disabled="
            isFieldDisabled || v.mrpDisabled.$model.includes(FieldName.INN)
          "
							@blur="v.inn.$touch"
						/>
					</v-col>
					<v-col cols="3">
						<v-text-field
							v-model="v.email.$model"
							:errorMessages="getValidationErrorText(v.email)"
							label="Адрес электронной почты"
							outlined
							:disabled="isFieldContactsDisabled"
							@blur="v.email.$touch"
						/>
					</v-col>
					<v-col cols="3">
						<v-text-field
							v-model="v.phone.$model"
							:errorMessages="getValidationErrorText(v.phone)"
							v-mask="Mask.PHONE"
							label="Контактный телефон"
							outlined
							:disabled="isFieldContactsDisabled"
							@blur="v.phone.$touch"
						/>
					</v-col>
					<v-col cols="12">
						<AddressStructuredField
							:value="v.address.$model"
							:global-disabled="isFieldDisabled"
							@change="v.address.$model = $event"
							:v="v.address"
							label="Место жительства или место пребывания"
							:notice-recovery="true"
							:translationKey="translationKey ? `${translationKey}.addr` : undefined"
						/>
					</v-col>
					<template v-if="isBusinessman">
						<v-col cols="4">
							<v-text-field
								v-model="v.ogrn.$model"
								:errorMessages="getValidationErrorText(v.ogrn)"
								v-mask="Mask.OGRNIP"
								label="ОГРНИП"
								outlined
								:disabled="isFieldDisabled"
								@blur="v.ogrn.$touch"
							/>
						</v-col>
						<v-col cols="4">
							<DateFieldCustom
								label="Дата гос. регистрации"
								:value="v.regDate.$model"
								@change="v.regDate.$model = $event"
								:errorMessage="v.regDate"
								:max="new Date().toISOString()"
								:disabled="isFieldDisabled"
								@blur="v.regDate.$touch"
							/>
						</v-col>
						<v-col cols="4">
							<v-text-field
								v-model="v.emailUl.$model"
								:errorMessages="getValidationErrorText(v.emailUl)"
								label="Адрес электронной почты, содержащийся в ЕГРИП"
								outlined
								:disabled="isFieldDisabled"
								@blur="v.emailUl.$touch"
							/>
						</v-col>
						<v-col cols="6">
							<v-text-field
								v-model="v.regPlace.$model"
								:errorMessages="getValidationErrorText(v.regPlace)"
								label="Место гос. регистрации"
								outlined
								:disabled="isFieldDisabled"
								@blur="v.regPlace.$touch"
							/>
						</v-col>
					</template>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import {
	maxLength,
	minLength,
	required,
	requiredIf,
	and,
} from 'vuelidate/lib/validators';

import DateFieldCustom from '@/components/base/DateFieldCustom';
import AddressStructuredField, {
	addressValidate,
} from '@/components/base/AddressStructuredField';
import {
	getValidationErrorText,
	EMOJI,
	EMAIL,
	MAX_LENGTH,
	MAX_LENGTH_EMAIL,
	DATE_FORMAT,
	DATE_FUTURE,
	DATE_PAST,
	MinLength,
	INN,
	PERSON_NAME, TRAILING_AND_LEADING_SPACES,
} from '@/utils/validate';
import {FieldName, Mask} from '@/constants';

export const personModel = {
	lastName: '',
	firstName: '',
	patronymic: '',
	birthDate: '',
	address: {},
	snils: '',
	inn: '',
	phone: '',
	email: '',
	isBusinessman: false,
	ogrn: '',
	regDate: '',
	regPlace: '',
	emailUl: '',
	mrpDisabled: [],
};

export const personValidation = {
	isBusinessman: {},
	lastName: {
		required,
		maxLength: maxLength(MAX_LENGTH),
		PERSON_NAME,
		TRAILING_AND_LEADING_SPACES
	},
	firstName: {
		required,
		maxLength: maxLength(MAX_LENGTH),
		PERSON_NAME,
		TRAILING_AND_LEADING_SPACES
	},
	patronymic: {
		maxLength: maxLength(MAX_LENGTH),
		PERSON_NAME,
		TRAILING_AND_LEADING_SPACES
	},
	birthDate: {
		required,
		DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
	},
	address: {
		required,
		...addressValidate(),
		TRAILING_AND_LEADING_SPACES
	},
	snils: {
		required,
		minLength: minLength(MinLength.SNILS),
	},
	inn: {
		required,
		minLength: minLength(12),
		INN: INN(12),
	},
	phone: {
		required,
		minLength: minLength(16),
	},
	email: {
		required,
		EMAIL,
		maxLength: maxLength(MAX_LENGTH_EMAIL),
		TRAILING_AND_LEADING_SPACES
	},
	ogrn: {
		required: requiredIf('isBusinessman'),
		minLength: minLength(15),
	},
	regDate: {
		required: requiredIf('isBusinessman'),
		DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
	},
	regPlace: {
		required: requiredIf('isBusinessman'),
		EMOJI,
		TRAILING_AND_LEADING_SPACES
	},
	emailUl: {
		required: requiredIf('isBusinessman'),
		EMAIL,
		maxLength: maxLength(MAX_LENGTH_EMAIL),
		TRAILING_AND_LEADING_SPACES
	},
	mrpDisabled: {},
};

export default {
	name: 'Person',
	props: {
		v: {
			type: Object,
			required: true,
		},
		isAlternativeServiceEdit: {
			type: Boolean,
			required: true,
		},
		isManual: {
			type: Boolean,
			default: true,
		},
		isBusinessman: {
			type: Boolean,
			default: true,
		},
		translationKey: {
			type: String,
			required: false
		}
	},
	components: {
		DateFieldCustom,
		AddressStructuredField,
	},
	data: () => ({
		Mask,
		FieldName,
		getValidationErrorText,

	}),
	computed: {
		isFieldDisabled() {
			if (!this.isManual) return false;

			return this.isManual && this.isAlternativeServiceEdit;
		},

		isFieldContactsDisabled() {
			if (!this.isManual) return false;

			return this.isManual && this.isAlternativeServiceEdit;
		},
	},
};
</script>
